import { useEffect, useState } from "react";
import Head from "next/head";
import Layout from "layout/Layout/index.js";
import Image from "next/image";
import SSS from "components/SSS/SSS";
import { getCloudServers, getCurrencyRates } from "services/allServices";
import Loader from "react-loader-spinner";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import productInfoJson from "ProductInfo.json";
import { useGlobalStore } from "store/GlobalStore";
import { useTranslation } from "next-i18next";
import { changeCurrency } from "helpers/helpersFunc";
import Button from "@/components/FormElements/Button";
import Link from "next/link";
import { useConfigurationStore } from "store/ConfigurationStore";
import SSSData from "public/SSS/sss-tr-bulut-sunucu.json";
import SSSDataEN from "public/SSS/sss-en-bulut-sunucu.json";
import { useRouter } from "next/router";
import { googleEventConfiguration } from "helpers/googleEvents";
import WhatIsCloudServer from "@/components/CloudServers/WhatIsCloudServer";
import CloudServersAdvantages from "@/components/CloudServers/CloudServersAdvantages";
import CloudRentalInstallationProcess from "@/components/CloudServers/CloudRentalInstallationProcess";
import ImportanceOfCloudTech from "@/components/CloudServers/ImportanceOfCloudTech";
import HighEfficiencyBestCloud from "@/components/CloudServers/HighEfficiencyBestCloud";
import MaxPerformanceWebSiteCloudServer from "@/components/CloudServers/MaxPerformanceWebSiteCloudServer";


function cloudServer({ datas, rates }) {
  const { t } = useTranslation(["common", "cloudServer"]);
  const router = useRouter();

  const [servers, setServers] = useState();
  const [setCurrencyRates, currencyRates, currencyType] = useGlobalStore((state) => [state.setCurrencyRates, state.currencyRates, state.currencyType]);
  const [setDefaultPaymentCycle, setSelectedServer, clearAllConfigurations, setConfigurationType] = useConfigurationStore((((state) => [state.setDefaultPaymentCycle, state.setSelectedServer, state.clearAllConfigurations, state.setConfigurationType])));
  const [cloudPrice, setCloudPrice] = useState(["0", "0"]);

  const onGetDedicatedServers = () => {
    let sortedData = datas.sort((a, b) => a.order - b.order);
    setServers(sortedData);
    calculatePrice(sortedData[0]?.one_month_price);
  };

  const calculatePrice = (p) => {
    let newPrice = changeCurrency(currencyRates, currencyType, parseFloat(p?.toFixed(2)));
    let price = newPrice;
    let splitedPrice = price.split(".");
    setDefaultPaymentCycle(1);
    if (datas[0]?.one_month_price > 0) {
      setDefaultPaymentCycle(1);
    } else if (datas[0]?.three_month_price > 0) {
      setDefaultPaymentCycle(3);
    } else if (datas[0]?.six_month_price > 0) {
      setDefaultPaymentCycle(6);
    } else if (datas[0]?.one_year_price > 0) {
      setDefaultPaymentCycle(12);
    } else if (datas[0]?.two_year_price > 0) {
      setDefaultPaymentCycle(24);
    } else if (datas[0]?.three_year_price > 0) {
      setDefaultPaymentCycle(36);
    }

    setCloudPrice(splitedPrice);
  };

  const setId = (id) => {
    clearAllConfigurations();
    setConfigurationType("server");
    setSelectedServer(id);

  };
  useEffect(() => {
    onGetDedicatedServers();
  }, []);
  useEffect(() => {
    setCurrencyRates(rates);
  }, [rates]);

  return (
    <Layout>
      <Head>
        <title>{t('cloudMetaTitle')}</title>
        <meta name="description" content={t('cloudMetaDescription')} />
        <meta property="og:title" content={t('cloudMetaTitle')} key="title" />
        <meta property="og:description" content={t('cloudMetaDescription')} key="description" />
      </Head>

      <div className="w-full bg-no-repeat transform-gpu bg-cloudServerBg">
        <div className="container px-4 py-20 mx-auto lg:px-0">
          <div className="flex justify-between mb-14">
            <div className="flex-1">
              <p className="text-xl">{t("cloudServer:title")}</p>
              <h1 className="my-3 text-5xl font-semibold">{t("cloudServer:title2")}</h1>
              <div dangerouslySetInnerHTML={{ __html: t("cloudServer:description") }}></div>
            </div>
            <div className="justify-end flex-1 hidden lg:flex">
              <Image
                src="/cloudImage.svg"
                alt="cloud"
                title="cloud"
                width="300"
                height="79"
                priority
                loading="eager"
                className="transform-gpu"
              />
            </div>
          </div>
          {/* <WindowsVirtualServersTable servers={servers} /> */}
          {servers ?
            <div className="grid grid-cols-2 gap-8">
              <div className="col-span-2 p-5 bg-white rounded-md shadow-md lg:col-span-1">
                <p className="text-3xl font-semibold">{servers[0].product_name}</p>
                <div className="grid grid-cols-3 gap-6 mt-6 lg:w-[400px]">
                  <div className="col-span-1">
                    <p className="text-sm text-textGray">CPU</p>
                    <p className="text-2xl font-semibold">{servers[0].cpu?.replace("GHz", "vCPU")}</p>
                    {/* Larmack vCPU olmalı dedi o yüzden yapıldı */}
                  </div>
                  <div className="col-span-1">
                    <p className="text-sm text-textGray">RAM</p>
                    <p className="text-2xl font-semibold">{servers[0].ram}</p>
                  </div>
                  <div className="col-span-1">
                    <p className="text-sm text-textGray">Disk</p>
                    <p
                      className="text-2xl font-semibold">{servers[0].disk.disk_size + " " + servers[0].disk.disk_unit}</p>
                  </div>
                  <div className="col-span-1">
                    <p className="text-sm text-textGray">{t('bandwidth')}</p>
                    <p className="text-2xl font-semibold">{servers[0].network}</p>
                  </div>
                  <div className="col-span-1">
                    <p className="text-sm text-textGray">{t('traffic')}</p>
                    <p className="text-2xl font-semibold">{servers[0].bandwidth}</p>
                  </div>
                  <div className="col-span-1">
                    <p className="text-sm text-textGray">IP</p>
                    <p
                      className="text-2xl font-semibold">{servers[0]?.ip_address === "/32" ? ("1 ") + t('unit') : servers[0]?.ip_address}</p>
                  </div>
                </div>

                <div className="flex items-center justify-between p-3 mt-3 rounded-md bg-[#F1F5F9]">
                  <div className="flex items-center">
                    <div className="flex">
                      <p className="text-3xl font-semibold text-titleColor">{cloudPrice[0]}.</p>
                      <div className="flex flex-col ml-1">
                        <span
                          className="p-0 m-0 text-sm font-semibold text-titleColor">{cloudPrice[1]} {currencyType}</span>
                        <span className="p-0 m-0 text-xs text-titleColor">{t("common:monthly")} + {t('extra')}</span>
                      </div>
                    </div>
                    <p className="ml-4">{t('startingPrice')}</p>
                  </div>

                  <Link href="/configuration" as={t("nav:configuration")}><Button
                    onClick={() => {
                      googleEventConfiguration(servers[0], servers[0].one_month_price, servers[0].currency, "product_page");
                      setId(servers[0]?.id)
                    }} name={servers[0]?.id}
                    buttonText={t("common:configure")}
                    buttonLeftIcon="ri-tools-fill" /></Link>

                </div>
              </div>

              <div className="grid col-span-2 p-5 bg-white rounded-md shadow-md lg:grid-cols-5 lg:col-span-1">
                <div className="flex flex-col justify-center lg:col-span-3">
                  <p className="text-2xl font-semibold text-makdosTitleDiv">{t("cloudServer:boxHeading")}</p>
                  <p className="mt-3 text-cardText">{t("cloudServer:boxParagraph")}</p>
                </div>
                <div className="lg:col-span-2">
                  <Image src="/cloudbox.svg" alt="cloud" title="Cloud" width="321" height="320" />
                </div>
              </div>
            </div>
            :
            <div className="flex justify-center w-full py-20">
              <Loader
                type="Oval"
                color="#FFDD00"
                height={50}
                width={50}
                timeout={3000} //3 secs
              />
            </div>
          }
        </div>

        <WhatIsCloudServer />

        <CloudServersAdvantages />

        <CloudRentalInstallationProcess />

        <ImportanceOfCloudTech />

        <HighEfficiencyBestCloud />

        <MaxPerformanceWebSiteCloudServer />
      </div>


      <div className="mt-20">
        <SSS data={router.locale === "tr" ? SSSData : SSSDataEN} />
      </div>
    </Layout>
  );
}

export default cloudServer;

export const getServerSideProps = async ({ locale }) => {
  let datas = {};
  await getCloudServers(productInfoJson.cloud_server).then(res => {
    let configureData = []
    configureData.push({
      product_name: res[0].product_name,
      cpu: res[0].cpu,
      cpu_core: res[0].cpu_core,
      ram: res[0].ram,
      disk: res[0].disk,
      one_month_price: res[0].one_month_price,
      three_month_price: res[0].three_month_price,
      six_month_price: res[0].six_month_price,
      one_year_price: res[0].one_year_price,
      two_year_price: res[0].two_year_price,
      three_year_price: res[0].three_year_price,
      currency: res[0].currency,
      stock: res[0].stock,
      network: res[0].network,
      ip_address: res[0].ip_address,
      bandwidth: res[0].bandwidth,
      id: res[0].id,
      group_group: {
        item_category_dict: res[0].group_group.item_category_dict,
        group_name: res[0].group_group.group_name,
      }
    })
    datas = res;
  });
  let rates = {};
  await getCurrencyRates().then(res => {
    rates = res;
  });

  return {
    props: {
      ...await serverSideTranslations(locale, ["common", "nav", "cloudServer"]),
      datas: datas,
      rates: rates
    }
  };
};